module.exports = __webpack_public_path__ + "static/media/imageIcon.4cdbb914.svg";